export const SET_CURRENT_LABS = 'SET_CURRENT_LABS'
export const SET_LOADING = 'SET_LOADING'
export const GET_LAB_CATEGORY = 'GET_LAB_CATEGORY'
